import { Page } from '@optools/components/layout/page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/unauthorized')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page title="Unauthorized">
      <h1 className="mb-2 text-xl font-bold">You do not have access to this tool</h1>
      <p className="text-sm">
        Please request access via the{' '}
        <a
          className="underline underline-offset-2"
          href="https://app.lumosidentity.com/app_store?domainAppId=841026"
          rel="noreferrer"
          target="_blank">
          MLB App Store.
        </a>
      </p>
    </Page>
  );
}
